import { jsx as _jsx } from "react/jsx-runtime";
import { Grow } from "@mui/material";
import { forwardRef } from "react";
import Draggable from "react-draggable";
export const createDraggableTransition = ({ TransitionComponent = Grow, draggableProps, transitionProps }) => forwardRef((props, ref) => (_jsx(Draggable, Object.assign({}, draggableProps, { children: _jsx(TransitionComponent, Object.assign({}, transitionProps, props, {
        ref,
        onEntered: (node) => {
            // Grow transition applies transitions for opacity and transform in a single css rule.
            // The transform transition makes draggable very slow and delayed.
            // This manipulation allows us to remove the transitions only when the popover is already opened and keep them for other states.
            node.style.transition = "";
        }
    })) }))));
//# sourceMappingURL=createDraggableTransition.js.map